export default {
  computed: {
    isOwner() {
      return this.item.staff_member === this.currentUser.profile.id;
    },
    isStaff() {
      return !this.isManager && !this.isPayroll && !this.isAdministrator;
    },
    isManager() {
      if (this.currentUser.profile.is_manager) return true;
      // Backward compatibility with full manager dict from API responses
      if (
        this.currentUser.profile.manager &&
        Object.keys(this.currentUser.profile.manager).length !== 0
      )
        return true;
      return false;
    },
    isPayroll() {
      var isPayroll = false;

      if (this.currentUser.groups) {
        this.currentUser.groups.forEach(function (group) {
          if (group.name === "Payroll") isPayroll = true;
        });
      }

      return isPayroll;
    },
    isAdministrator() {
      var isAdministrator = false;

      if (this.currentUser.groups) {
        this.currentUser.groups.forEach(function (group) {
          if (group.name === "Administrator") isAdministrator = true;
        });
      }

      return isAdministrator;
    },
  },
};
